/* eslint-disable no-console */
const EMPTY_FN = () => {};
const debugLogger = console;
const emptyLogger = {};
Object.keys(console).forEach(key => {
  const value = console[key];
  if (typeof value === 'function') {
    emptyLogger[key] = EMPTY_FN;
  }
});
export default process.env.NODE_ENV === 'production' ? emptyLogger : debugLogger;